import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Layout from "../../../layout/default";
import Block from "../../../components/Block/Block";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import axios from "axios";
import { Icon } from "../../../components";
import api from "../../../services/auth/api";

// const baseURL = process.env.SSP_BASE_URL_BACKEND;
// const baseURL = "http://127.0.0.1:8000/";

function ProductVariant() {
  const { id } = useParams();
  const [data, setData] = useState({
    title: "",
    description: "",
    price: 0,
    unit_id: "",
    unit_quantity: "",
    discount: "",
    product_id: id,
  });

  const [validated, setValidated] = useState(false);

  let name, value;
  const handleInputs = (e) => {
    name = e.target.name;
    value = e.target.value;
    setData({ ...data, [name]: value });
  };


  // const _header = { "Content-Type": "application/json", accept: "*/*" };
  const postData = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    } else {
      event.preventDefault();
      const formData = new FormData();

      // Append all data to FormData
      for (const key in data) {
        formData.append(key, data[key]);
      }

      api
        .post(`${process.env.REACT_APP_HOST}api/product-variant`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.data.success) {
            saveSuccess();
            clear(); // Clear the form after success
            setValidated(false);
          }
        })
        .catch((err) => {
          // Handle errors
          saveError(err.response?.data?.message || "An error occurred");
        });

      setValidated(true);
    }
  };


  const clear = () => {
    setData({
      title: "",
      description: "",
      // image: "",
      price: 0,
      // product_id: "",
      // category_id: "",
      unit_id: "",
      unit_quantity: "",
      discount: "",
    });
  };

  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    setImage(selectedFile); // Store the selected file

    // Display a preview of the image
    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  // const [CategoryListData, setCategoryListData] = useState([]);
  // const [ProductListData, setProductListData] = useState([]);
  const [UnitListData, setUnitListData] = useState([]);

  // const getList = () => {
  //   const response = api
  //     .get(baseURL + `api/category`)
  //     .then((response) => {
  //       setCategoryListData(response.data.data);
  //     })
  //     .catch((err) => {
  //       setCategoryListData([]);
  //     });
  // };

  // const getProductList = () => {
  //   const response = api
  //     .get(baseURL + `api/products`)
  //     .then((response) => {
  //       setProductListData(response.data.data);
  //     })
  //     .catch((err) => {
  //       setProductListData([]);
  //     });
  // };

  const getUnitList = () => {
    const response = api
      .get(`${process.env.REACT_APP_HOST}api/unit`)
      .then((response) => {
        setUnitListData(response.data);
      })
      .catch((err) => {
        setUnitListData([]);
      });
  };

  useEffect(() => {
    // getList();
    // getProductList();
    getUnitList();
  }, []);



  const navigate = useNavigate();
  const saveSuccess = () => {
    Swal.fire({
      icon: "success",
      title: "Saved successfully",
      // text: "You clicked the button!",
    }).then(() => navigate("#"));
  };

  const saveError = (message) => {
    let errorMessage;
    if (typeof message === "object") {
      errorMessage = Object.values(message).join("<br>");
    } else {
      errorMessage = message;
    }
    Swal.fire({
      icon: "error",
      title: "Save attempt was not successful",
      html: errorMessage,
    });
  };

  return (
    <Layout title="Product Variant">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Product Variant</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Link
                  to="/shop/admin/product-list"
                  className="btn btn-primary btn-md d-md-none"
                >
                  <Icon name="arrow-long-left" />
                  <span>Go to List</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/shop/admin/product-list"
                  className="btn btn-primary d-none d-md-inline-flex"
                >
                  <Icon name="arrow-long-left" />
                  <span>Go to List</span>
                </Link>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block className="mt-n5">
        {/* <Form action="#"> */}
        <Form noValidate validated={validated} onSubmit={postData}>
          <Row className="g-3 ">
            <Card>
              <Card.Body>
                {/* <h3>Farmers Details</h3> */}
                <Row className="g-gs">
                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="product">
                        Product Variant Title<span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          id="title"
                          name="title"
                          value={data.title}
                          onChange={handleInputs}
                          type="text"
                          placeholder="Enter Product Variant Title"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Product Variant Name is required
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="title">
                        Product Variant Description
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          id="description"
                          name="description"
                          value={data.description}
                          onChange={handleInputs}
                          type="text"
                          placeholder="Enter Product Variant Description"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Product Variant Description.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Row>
        </Form>
      </Block>

      <Block className="mt-2">
        <Form noValidate validated={validated} onSubmit={postData}>
          <Row className="g-3">
            <Card>
              <Card.Body>
                <Row className="g-gs">
                  {/* Discount Field */}
                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="discount">
                        Discount<span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          id="discount"
                          type="number"
                          name="discount"
                          value={data.discount}
                          onChange={handleInputs}
                          placeholder="Enter Discount"
                          required
                          min="0"
                          step="0.01"
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  {/* Unit ID Field */}
                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label>
                        Unit <span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Select
                          name="unit_id"
                          value={data.unit_id}
                          onChange={handleInputs}
                          required
                          isInvalid={
                            data.unit_id === undefined ||
                            data.unit_id === "0"
                          }
                        >
                          <option value="0">Select Unit</option>
                          {UnitListData.map((unit) => (
                            <option key={unit.id} value={unit.id}>
                              {unit.title}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </Col>

                  {/* Unit Quantity Field */}
                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="unit_quantity">
                        Unit Quantity<span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          id="unit_quantity"
                          type="number"
                          name="unit_quantity"
                          value={data.unit_quantity}
                          onChange={handleInputs}
                          placeholder="Enter Unit Quantity"
                          required
                          min="1"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="price">
                        Price<span className="text-danger">*</span>
                      </Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control
                          id="price"
                          type="number"
                          name="price"
                          value={data.price}
                          onChange={handleInputs}
                          placeholder="Enter price"
                          required
                          min="0"
                          step="0.01"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <div className="gap-col">
              <ul className="d-flex align-items-center justify-content-center gap g-3">
                <li>
                  <Button type="submit" variant="primary" onSubmit={postData}>
                    Save
                  </Button>
                </li>
                <li>
                  <Button type="button" variant="secondary" onClick={clear}>
                    Cancel
                  </Button>
                </li>
              </ul>
            </div>
          </Row>
        </Form>
      </Block>
    </Layout>
  );
}

export default ProductVariant;
